import styled from "styled-components";
export const AllChancesStyle = styled.div``;
